import React from 'react';
import { MapPin, Target } from 'lucide-react';
import { SA_PROVINCES, SERVICE_RADIUS_OPTIONS } from '../../config/provinces';

/** Step 3 of 5 — Area. Structured province + city/suburb + service radius. */
const StepArea = ({ data, onChange }) => (
  <div className="space-y-6">
    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
        <MapPin size={16} /> Province *
      </label>
      <select
        data-testid="area-province-select"
        value={data.province}
        onChange={(e) => onChange({ province: e.target.value })}
        className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-[#37b34a] focus:border-transparent outline-none"
      >
        <option value="">Select a province…</option>
        {SA_PROVINCES.map((p) => <option key={p} value={p}>{p}</option>)}
      </select>
    </div>

    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-2">City / Suburb *</label>
      <input
        type="text" data-testid="area-city-input" value={data.city}
        onChange={(e) => onChange({ city: e.target.value })}
        placeholder="e.g., Sandton"
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#37b34a] focus:border-transparent outline-none"
      />
    </div>

    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
        <Target size={16} /> Service Radius (km) *
      </label>
      <div className="flex flex-wrap gap-2 mb-2">
        {SERVICE_RADIUS_OPTIONS.map((km) => (
          <button
            key={km} type="button" onClick={() => onChange({ serviceRadiusKm: km })}
            data-testid={`area-radius-chip-${km}`}
            className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
              data.serviceRadiusKm === km
                ? 'bg-[#37b34a] text-white border-[#37b34a]'
                : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50'
            }`}
          >
            {km} km
          </button>
        ))}
      </div>
      <input
        type="number" min="1" max="500" data-testid="area-radius-input"
        value={data.serviceRadiusKm}
        onChange={(e) => onChange({ serviceRadiusKm: parseInt(e.target.value, 10) || 0 })}
        className="w-32 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#37b34a] focus:border-transparent outline-none"
      />
    </div>
  </div>
);

export default StepArea;
